import React from 'react';
import MultiDataSourceTopChartsPage from '../components/MultiDataSourceTopChartsPage';
import { MultiDataSourceTopChartsPageType, MultiDataSourceTopChartsPageConfigMapping } from '../_config/pageConfigs';

const pageConfig = MultiDataSourceTopChartsPageConfigMapping[MultiDataSourceTopChartsPageType.Revenue];

interface IRevenueProps {
  /** Mobile Games 入口传入独立的筛选器继承作用域；复用页面不传。 */
  pageId?: string;
}

const Revenue: React.FC<IRevenueProps> = ({ pageId }) => {
  return <MultiDataSourceTopChartsPage pageConfig={pageConfig} pageId={pageId} />;
};

export default Revenue;
